import { Injectable } from '@angular/core';
import {
    HttpEvent,
    HttpHandler,
    HttpInterceptor,
    HttpRequest
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable()
export class ProjectIdInterceptor implements HttpInterceptor {

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {

        // Respect explicit project headers set by callers (e.g., agent-specific project context).
        if (req.headers.has('X-Project-Id')) {
            return next.handle(req);
        }

        // Do nothing if project ID is not defined
        if (!environment.XprojectId) {
            return next.handle(req);
        }

        const clonedRequest = req.clone({
            setHeaders: {
                'X-Project-Id': environment.XprojectId
            }
        });

        return next.handle(clonedRequest);
    }
}
